import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import IcoRedeem from "src/assets/images/icoRedeem.svg";
import cn from "classnames";

interface IRedeemImgProps {
  data: any;
}

const RedeemListItem = (props: IRedeemImgProps) => {
  // 글로벌
  const navigate = useNavigate();
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;

  const moveToDetail = (v: any) => {
    // console.log(v);
    navigate(`/redeem-detail/` + v.img_idx);
  };

  return (
    <>
      {props.data
        .filter((e: any) => e.type !== null)
        .map((v: any, i: number) => {
          return (
            <RedeemLinkBox className={cn({ check: v.type === "E", complete: v.type === "C" })} key={i}>
              <div onClick={(t) => moveToDetail(v)}>
                <img src={imageServerIp + v.img_url} alt="더미이미지" />
              </div>
            </RedeemLinkBox>
          );
        })}
    </>
  );
};

const RedeemLinkBox = styled.li`
  position: relative;
  margin-right: 8px;
  font-size: 0;
  &:last-child {
    margin-right: 15px;
  }
  &.check {
    > div {
      &:before {
        content: "";
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: block;
        border: 2.5px solid ${({ theme }) => theme.color.main};
      }
      &:after {
        content: "";
        z-index: 1;
        position: absolute;
        top: 8px;
        right: 8px;
        display: block;
        width: 20px;
        height: 20px;
        background: url(${IcoRedeem}) no-repeat 0 0;
      }
    }
  }
  &.complete {
    div {
      position: relative;
      &:before {
        content: "";
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(37, 47, 80, 0.5);
      }
    }
  }
  > div {
    overflow: hidden;
    position: relative;
    display: inline-block;
    width: 104px;
    padding-top: 100%;
    background: #f4f4f4;
    > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export default RedeemListItem;
